
import { Vue, Component, Prop } from 'vue-property-decorator';
import { RecentShipment } from '@/features/dashboard/types';
import { PackageType } from '@/features/shipment/types';
import { getCarrierLogoCode, getDisplayCarrierCode } from '@/features/common/helpers/carrier';

@Component
export default class ShipmentItem extends Vue {
  @Prop({ required: true }) shipment!: RecentShipment;

  @Prop({ required: true }) labelStyle!: string;

  private PackageType = PackageType;

  private getCarrierLogoCode = getCarrierLogoCode;

  private getDisplayCarrierCode = getDisplayCarrierCode;
}
